import { render, staticRenderFns } from "./ORDER_ASSIGN.vue?vue&type=template&id=78d4ad6a"
import script from "./ORDER_ASSIGN.vue?vue&type=script&lang=js"
export * from "./ORDER_ASSIGN.vue?vue&type=script&lang=js"
import style0 from "./ORDER_ASSIGN.vue?vue&type=style&index=0&id=78d4ad6a&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports